// extracted by mini-css-extract-plugin
module.exports = {"root":"iJvQvz","withFilters":"c7tp7nY","rootWithSideArrows":"yNs-qV","controls":"s1bSXD","sliderB2b":"iYS--q","slider":"eTwEte","filter":"xvaE_P"};